<template>
  <fieldset class="equipment-services" :disabled="disabled">
    <legend class="equipment-services-title">{{ $t('EquipmentServices.title') }}</legend>
    <p class="equipment-services-hint">{{ $t('EquipmentServices.hint') }}</p>
    <div class="equipment-services-options">
      <button
        v-for="row in rows"
        :key="row.key"
        type="button"
        class="equipment-service"
        :class="optionClass(row)"
        role="checkbox"
        :aria-checked="isSelected(row.key) ? 'true' : 'false'"
        :aria-label="chipLabel(row)"
        :title="hintFor(row)"
        :disabled="disabled || (!isSelected(row.key) && isBlocked(row)) || (isSelected(row.key) && isLocked(row))"
        @click="toggle(row.key, !isSelected(row.key))"
      >
        <v-icon v-if="isSelected(row.key)" class="equipment-service-check" size="14">mdi-check</v-icon>
        <span class="equipment-service-name">{{ $t('EquipmentServices.' + row.key) }}</span>
        <span class="equipment-service-count">{{ row.assigned }}/{{ row.contracted }}</span>
      </button>
    </div>
    <p v-if="!value.length" class="equipment-services-error">{{ $t('EquipmentServices.required') }}</p>
  </fieldset>
</template>

<script>
export default {
  props: {
    value: { type: Array, default: () => [] },
    rows: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    isSelected (key) {
      return this.value.includes(key)
    },
    isBlocked (row) {
      return typeof row.blocked === 'boolean' ? row.blocked : row.assigned >= row.contracted
    },
    isLocked (row) {
      return !!row.locked
    },
    optionClass (row) {
      return {
        'is-selected': this.isSelected(row.key),
        'is-blocked': !this.isSelected(row.key) && this.isBlocked(row),
        'is-exceeded': row.assigned > row.contracted
      }
    },
    chipLabel (row) {
      return `${this.$t('EquipmentServices.' + row.key)}. ${this.hintFor(row)}`
    },
    hintFor (row) {
      if (this.isLocked(row)) return this.$t('EquipmentServices.inProgressLock')
      if (row.assigned > row.contracted) {
        return `${this.$t('EquipmentServices.assigned', row)} · ${this.$t('EquipmentServices.exceeded')}`
      }
      return this.$t(row.assigned >= row.contracted ? 'EquipmentServices.full' : 'EquipmentServices.assigned', row)
    },
    toggle (key, checked) {
      this.$emit('input', checked ? [...this.value.filter(item => item !== key), key] : this.value.filter(item => item !== key))
    }
  }
}
</script>

<style scoped lang="stylus">
$svc-ink = #263238
$svc-muted = #546e7a
$svc-line = #e0e6ea
$svc-brand = #0091d5
$svc-error = #c62828

.equipment-services
  border 0
  padding 0
  margin 12px 0 2px
  min-width 0

.equipment-services-title
  display block
  padding 0
  font-size 0.8125rem
  font-weight 600
  line-height 1.3
  color $svc-ink

.equipment-services-hint
  margin 2px 0 8px
  font-size 0.75rem
  line-height 1.35
  color $svc-muted

.equipment-services-options
  display flex
  flex-wrap nowrap
  gap 8px

.equipment-service
  display inline-flex
  align-items center
  justify-content center
  gap 5px
  flex 1 1 0
  min-width 0
  margin 0
  padding 6px 8px
  font inherit
  color $svc-ink
  background #fff
  border 1px solid $svc-line
  border-radius 999px
  cursor pointer
  transition border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease

.equipment-service:hover:not(:disabled)
  border-color #b0bec5
  background #fafbfc

.equipment-service:focus
  outline none

.equipment-service:focus-visible
  border-color $svc-brand
  box-shadow 0 0 0 3px rgba(0, 145, 213, 0.16)

.equipment-service.is-selected
  border-color $svc-brand
  background $svc-brand
  color #fff

.equipment-service.is-selected:hover:not(:disabled)
  background #0084c4
  border-color #0084c4

.equipment-service.is-blocked,
.equipment-service:disabled
  cursor not-allowed
  background #f7f9fa

.equipment-service.is-selected:disabled
  background $svc-brand
  border-color $svc-brand
  color #fff
  opacity 0.85

.equipment-service.is-blocked:not(.is-selected)
  color #78909c

.equipment-service-check
  flex-shrink 0

.equipment-service.is-selected >>> .equipment-service-check
  color #fff !important

.equipment-service.is-exceeded.is-selected
  border-color $svc-error
  background $svc-error
  color #fff

.equipment-service.is-exceeded.is-selected:hover:not(:disabled)
  background #b71c1c
  border-color #b71c1c

.equipment-service-name
  min-width 0
  overflow hidden
  text-overflow ellipsis
  white-space nowrap
  font-size 0.8125rem
  font-weight 600
  line-height 1.2

.equipment-service-count
  flex-shrink 0
  font-size 0.6875rem
  font-weight 600
  line-height 1
  letter-spacing 0.01em
  opacity 0.72

.equipment-service.is-selected .equipment-service-count
  opacity 0.9

.equipment-services-error
  margin 8px 0 0
  font-size 0.75rem
  line-height 1.35
  color $svc-error
</style>



// WEBPACK FOOTER //
// SurveyWorkServices.vue?25c94ed2